import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { LoaderService } from '../loader/loader.service';
import { DxPopupModule } from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule,
    DxPopupModule
  ],
  declarations: [
    LoaderComponent
  ],
  providers: [
    LoaderService
  ],
  exports: [
    LoaderComponent
  ]
})
export class LoaderModule { }
